import { useState } from "react"
import { FiBell, FiCheckCircle, FiChevronDown, FiChevronRight, FiMic, FiPause, FiPhone, FiX, FiXCircle } from "react-icons/fi"
import supportStore from "../../../stores/useSupport"


export const Header = ({}) => {
    const [status, setStatus] = useState(false)
    const {primaryColor} = supportStore(state=>state)
    return (
        <header class="h-[70px] w-full
        grid grid-cols-6 lg:grid-cols-12 scrollbar items-center justify-center" >
       
        <div class="primarylight h-full col-span-3 flex items-center px-4" >
          <div class="flex gap-3 items-center">  
            <img 
                src={`/images/demo/circle-${primaryColor}.svg`} 
            class="h-14" />
            <p class="font-medium text-2xl text-white">Support</p>
          </div>
        </div>
        <div class="primary hidden h-full lg:flex col-span-6 pr-3 p-1 items-center justify-between ">
            <div class="search opac bg-white/30 h-10 rounded-md w-full mx-4 mr-20">
                <input type="text" placeholder="Search" class="border-none bg-transparent w-full h-full px-2 outline-none font-medium" />
            </div>
  
            
            {/** CALL STATUS **/}
              <ul class=" flex items-center h-full gap-3">
                <li>
                    <div class="h-12 w-12 bg-black/20 hover:bg-black/30 rounded-full cursor-pointer flex items-center justify-center">
                    <FiPause size={23} class="h-12 stroke-none fill-white" />
                    </div>
                </li>
                <li>
                  <div class="h-12 w-12 bg-black/20 hover:bg-black/30 rounded-full cursor-pointer flex items-center justify-center">
                  <FiMic size={23} class="h-12 stroke-white" />
                  </div>
              </li>
              <li>
                  <div class="h-12 w-12 bg-red-400 hover:bg-red-500 rounded-full cursor-pointer flex items-center justify-center">
                  <FiPhone size={23} class="h-12 stroke-none fill-white" />
                  </div>
              </li>
                <li>
                  <div class="h-12 w-12 hidden rounded-full cursor-pointer flex items-center justify-center">
                  <FiX size={23} class="h-12 stroke-white" />
                  </div>
              </li>
              </ul>
            {/** END CALL STATUS **/}
  
        </div>
        <div class="primarylight h-full col-span-3 flex gap-2 items-center justify-between px-10" >
  
            <div></div>
        
  
          <div class="flex ">
            
            <Notification />
        
            <Profile />
          </div>
  
  
        </div>
      </header>
    )
}



export const Notification = () => {
    const [status, setStatus] = useState(false)
    return (
        <div 
            onClick={()=>setStatus(!status)}
            class="relative flex hover:bg-white/20 rounded-full w-12 h-12 items-center justify-center cursor-pointer">
             <FiBell size={23} class="h-12 text-white" />
              <span class="flex h-2 w-2 absolute top-2 right-2">
                  <span class="animate animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
              </span>
             {/** OPTIONS COMPONENT **/}
             {status && (
            <div
            // :className="status == true ? 'block':'hidden'"
            className="dropdown absolute right-0 top-14 z-10 divide-y border dark:border-zinc-700 
            dark:border-zinc-900 bg-white dark:bg-zinc-800 rounded-lg w-72 z-[55]"
            >
              <div className="my-3">
              <div className="flex items-center justify-between mx-3 mb-5">
                  <div className="flex items-center gap-2">
                  <div
                      className="text-sm bg-red-500 rounded-full w-5 h-5 text-white font-medium flex items-center justify-center"
                  >
                      5
                  </div>
                  <div className="font-semibold dark:text-white">Notifications</div>
                  </div>
                  <div className="flex">
                  <div
                      className="border-b-2 border-gray-200 dark:border-gray-500 text-sm text-gray-500 dark:text-gray-300 cursor-pointer p-1 px-3"
                  >
                      Unread
                  </div>
                  <div
                      className="border-b-2 border-blue-500 text-sm text-gray-500 dark:text-gray-300 cursor-pointer p-1 px-3"
                  >
                      All
                  </div>
                  </div>
              </div>
              <ul className="m-3">
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-3.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jane Doe
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Sent message
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          10 hours ago
                      </div>
                      </div>
                  </div>
                  </li>
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-4.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Missed call from
                          </div>
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jasmine
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          1 days ago
                      </div>
                      <div
                          className="bg-gray-200 dark:bg-gray-600 cursor-pointer p-1 px-3 my-2 rounded-md w-max flex items-center justify-center text-gray-500 dark:text-gray-300"
                      >
                          <i
                          data-feather="phone"
                          className="text-gray-500 dark:text-gray-300 h-4"
                          ></i>
                          <p>Call Back</p>
                      </div>
                      </div>
                  </div>
                  </li>
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-5.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jessica
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Added you
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          2 days ago
                      </div>
                      <div className="flex gap-2">
                          <div
                          className="bg-blue-500 cursor-pointer p-2 px-3 my-2 rounded-md w-max flex items-center justify-center text-white text-sm"
                          >
                          <FiCheckCircle size={23}
                              className="text-gray-500 h-4 text-white"
                          />
                          <p>Accept</p>
                          </div>
                          <div
                          className="bg-gray-200 dark:bg-gray-600 cursor-pointer p-2 px-3 my-2 rounded-md w-max flex items-center justify-center text-gray-500 dark:text-gray-300 text-sm"
                          >
                          <FiXCircle size={23}
                              className="text-gray-500 dark:text-gray-300 h-4"
                          />
                          <p>Reject</p>
                          </div>
                      </div>
                      </div>
                  </div>
                  </li>
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-7.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jamie
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Sent message
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          1 weeks ago
                      </div>
                      </div>
                  </div>
                  </li>
              </ul>
              </div>
            </div>
              )}
            </div>
    )
}


export const Profile = () => {
    const [status, setStatus] = useState(false)

    return (
        
        <div class="relative hidden lg:flex gap-2 items-center cursor-pointer text-white">
        <div class="h-12 w-12 rounded-full bg-white/50"></div>
        <div class=""
            onClick={()=>setStatus(!status)}
         >
           <div class="text-lg font-medium">John Doe</div>
           <p class="text-sm">Online</p>
         </div>
         {status && <div> <FiChevronDown size={23} class="h-5 font-medium" /></div>}
         {!status && <div> <FiChevronRight size={23} class="h-5 font-medium" /></div> }

        {status && (
            <div class="z-10 absolute right-0 top-16 text-black z-[999] bg-white divide-y divide-gray-100 
            rounded-lg --shadow w-44 dark:bg-zinc-800 dark:divide-zinc-700">
             <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownInformationButton">
               <li>
                 <a href="#" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-zinc-700 dark:hover:text-white">Dashboard</a>
               </li>
               <li>
                 <a href="#" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-zinc-700 dark:hover:text-white">Settings</a>
               </li>
               <li>
                 <a href="#" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-zinc-700 dark:hover:text-white">Earnings</a>
               </li>
             </ul>
             <div class="py-2">
               <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-zinc-700 dark:text-gray-200 dark:hover:text-white">Sign out</a>
             </div>
         </div>
        )}

     </div>
    )
}